import { render, staticRenderFns } from "./HistoryCommonHeader.vue?vue&type=template&id=06d1d998&scoped=true&"
import script from "./HistoryCommonHeader.vue?vue&type=script&lang=js&"
export * from "./HistoryCommonHeader.vue?vue&type=script&lang=js&"
import style0 from "./HistoryCommonHeader.vue?vue&type=style&index=0&id=06d1d998&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06d1d998",
  null
  
)

export default component.exports